import React from 'react';
import './PolicyServarianismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {POLICY_SERVARIANISM_UNIT_BONUS_SIZE_THRESHOLD} from "../../../../configs/policy/servarianism";

const PolicyServarianismDescription = () => {
  const mine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left-only'}
    src={'/img/hexes/mine.ecae90cd.png'}
    alt={'Рудник'}
    title={'Рудник'}
  />;

  const superMine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/super_mine.7a4a81f7.png'}
    alt={'Великий рудник'}
    title={'Великий рудник'}
  />;

  const barracks1 = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const barracks2 = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />


  const unitSize = <img
    className={'policy-description-icon'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const coins1 =
    <CoinsStat
      text={'+1'}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const coins2 =
    <CoinsStat
      text={'+2'}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const unitSizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={`${POLICY_SERVARIANISM_UNIT_BONUS_SIZE_THRESHOLD}+`}
    icon={unitSize}
  />

  return (
    <>
      <div className={'policy-description_line'}>
        Доход {mine}{superMine}:
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        • {coins1}, если смежно {barracks1} ИЛИ {unit}{unitSizeValueAndIcon},
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        • {coins2}, если смежно И {barracks2}, И {unit}{unitSizeValueAndIcon}.
      </div>
    </>
  );
};

export default PolicyServarianismDescription;
